import React, { Component } from 'react'
import { AppSettings } from '../../appSettings'

let FORM_SUPPORT_URL: string;
AppSettings.get('FORM_SUPPORT_URL').then(value => {
  FORM_SUPPORT_URL = value;
});

export class Home extends Component{

  render() {
    return (
      <div className="tc">
        <h1>I Hope You Know What You're Doing</h1>
        <h3>
          Share your sugestions for new features <a href={FORM_SUPPORT_URL}>here.</a>
        </h3>
        <img src={require('../../assets/images/greatPowersGreatResponsability.gif')} alt=""/>
      </div>
    )
  }
}